import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { logoutUser } from '../../store/slices/authSlice';
import Header from '../../layout/Header'
import MobileNav from '../../layout/MobileNav'
import ButtonLinkCharcoal from '../../components/buttons/ButtonLinkCharcoal';
import PageNavAccount from '../../layout/PageNavAccount';
import {Helmet} from "react-helmet";

const AccountOverview = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { user, token } = useSelector((state) => state.auth);

  React.useEffect(() => {
    if (!token) {
      navigate('/login');
    }
  }, [token, navigate]);

  const handleLogout = () => {
    dispatch(logoutUser());
    navigate('/login');
  };

  if (!user) {
    return (
      <div className="pt-[80px] px-5">
        <div className="max-w-2xl mx-auto text-center py-16 text-gray-500">Loading...</div>
      </div>
    );
  }

  const initials = `${user.firstname?.[0] ?? ''}${user.lastname?.[0] ?? ''}`.toUpperCase();

  return (
    <>
      <Helmet>
          <title>Account Overview | Oreca Pro</title>
          <link rel="canonical" href={window.location.href} />
      </Helmet>
      <Header />
      <MobileNav />
      <div className='py-[80px] px-5 max-w-[1100px] mx-auto'>
        <h1 className='text-2xl font-semibold mb-2 md:mt-8'>Account</h1>
        <PageNavAccount />
        
        <div className='max-w-[400px] mx-auto mt-10'>
            <div className="flex-shrink-0">
            <div className="w-20 h-20 rounded-full bg-indigo-600 flex items-center justify-center text-white text-2xl font-semibold">
                {initials || 'U'}
              </div>
            </div>

            <div className='my-5'>
              <p className="text-sm text-custom-light-grey">Full Name</p>
              <p className="text-lg font-medium text-white">{user.firstname} {user.lastname}</p>
            </div>

            <div className='my-5'>
              <p className="text-sm text-custom-light-grey">Email</p>
              <p className="text-lg font-medium text-white">{user.email}</p>
            </div>

            <div>
              <p className="text-sm text-custom-light-grey">Mobile</p>
              <p className="text-lg font-medium text-white">{user.mobile_number || '—'}</p>
            </div>

            <div className='my-5'>
              <p className="text-sm text-custom-light-grey">Member Since</p>
              <p className="text-lg font-medium text-white">
                {user.created_at ? new Date(user.created_at).toLocaleDateString() : '—'}
              </p>
            </div>

            <div className='mt-8'>
              <ButtonLinkCharcoal href="/account/edit" text="Manage Account" />
            </div>
        </div>
      </div>
    </>
  ) 
};

export default AccountOverview;
